@if (label()) {
  <span class="dialog-header__label">
    {{ label() }}
  </span>
}
@if (withCloseBtn()) {
  <button
    class="btn dialog-header__close-button"
    [attr.aria-label]="'textToSpeech.close' | transloco"
    (click)="close.emit()"
  >
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
}
